<template>
  <div class="container-fluid clinic-payments" style="margin-top: 40px">
    <!-- SHOW INVOICE -->
    <customer-show-invoice ref="showinvoice" :customer="selected_customer" :clinic="clinic"
      @submit="onSubmit"></customer-show-invoice>
    <!-- SHOW PAYMENT -->
    <customer-show-payment ref="showpayment" :customer="selected_customer" @submit="onSubmit"></customer-show-payment>
    <!-- NEW BANK ORDER -->
    <clinic-new-bank-order ref="newbankorder" @submit="doGenerateBankOrder"></clinic-new-bank-order>

    <!-- INVOICE SUMMARY -->
    <b-modal ref="invoicepending" title="Facturar Pendientes" hide-footer>
      <div class="container-fluid">
        <div class="row form-group">
          <div class="col-sm-12">
            <legend>Periodo</legend>
          </div>

          <div class="col-sm-4">
            <input v-model="date_from" id="invoice_pending_date_from" type="date" class="form-control" disabled
              readonly />
            <label class="wabident-info" for="invoice_pending_date_from">Fecha desde:</label>
          </div>

          <div class="col-sm-4">
            <input v-model="date_to" id="invoice_pending_date_to" type="date" class="form-control" disabled readonly />
            <label class="wabident-info" for="invoice_pending_date_to">Fecha hasta:</label>
          </div>

          <div class="col-sm-4">
            <select id="simulated_invoices_date_type" v-model="simulated_invoices_date_type" class="custom-select">
              <option value="choose">Elegir fecha</option>
              <option value="payment">Fecha de pago</option>
            </select>
            <label for="simulated_invoices_date_type" class="wabident-info">Fecha de factura</label>
          </div>

          <div v-if="simulated_invoices_date_type == 'choose'" class="col-sm-4 mt-2">
            <input v-model="simulated_invoices_date" id="invoice_pending_invoice_date" type="date"
              class="form-control" />
            <label class="wabident-info" for="invoice_pending_invoice_date">Elige fecha( Por defecto día
              actual)</label>
          </div>

          <div class="col-sm-12 mt-2">
            <legend v-if="simulating_invoices">
              Simulando ... <i class="fas fa-spin fa-spinner"></i>
            </legend>
            <legend v-else>Simulación</legend>
          </div>

          <div class="col-sm-12" v-if="!simulating_invoices && simulated_invoices">
            <strong class="mb-2">Total facturas: {{ simulated_invoices.payments.length }}
            </strong>
            <table class="table table-sm">
              <thead>
                <tr>
                  <th>F. PAGO</th>
                  <th>PACIENTE</th>
                  <th>LINEAS</th>
                  <th>TOTAL(€)</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(invoice, index) in simulated_invoices.payments" :key="index">
                  <td>{{ getInvoicePayDate(invoice.pay_date) }}</td>
                  <td>
                    <a class="btn-link" :href="`/customer/${invoice.customer_id}/edit`" target="_blank">
                      {{
                        getInvoiceCustomer(
                          invoice,
                          simulated_invoices.customers
                        )
                      }}
                    </a>
                  </td>
                  <td>{{ invoice.total_lines }}</td>
                  <td>{{ invoice.total_amount }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="col-sm-12 d-flex justify-content-between">
            <button @click="cancelSimulatedInvoices" class="btn btn-primary btn-wabident">
              Cancelar
            </button>
            <button :disabled="simulating_invoices &&
              simulated_invoices &&
              simulated_invoices.length
              " @click="confirmGenerateInvoices" class="btn btn-primary btn-wabident">
              Facturar
            </button>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- END INVOICE SUMMARY -->

    <div class="row">
      <!-- LEFT COLUMN -->
      <div class="col-md-2">
        <h1 class="clinic-payments__title">RESUMEN</h1>

        <div v-if="this.deposits && this.deposits.total > 0" class="clinic-payments__summary">
          <h5><strong>DEPÓSITOS: </strong> {{ total_deposits }}</h5>
          <ul>
            <li><b>Efectivo: </b> {{ fmtMoney(this.deposits.cash) }}</li>
            <li><b>Tarjeta: </b> {{ fmtMoney(this.deposits.credit_card) }}</li>
            <li><b>Financ.: </b> {{ fmtMoney(this.deposits.direct_debit) }}</li>
            <li>
              <b>Int. Fin: </b> {{ fmtMoney(this.deposits.expense_interests) }}
            </li>
            <li><b>Bizum: </b> {{ fmtMoney(this.deposits.mobile) }}</li>
            <li><b>Transf.: </b> {{ fmtMoney(this.deposits.transfer) }}</li>
            <li><b>TPV: </b> {{ fmtMoney(this.deposits.tpv) }}</li>
            <li v-if="enable_sepa_transfers"><b>Adeudo SEPA: </b> {{ fmtMoney(this.deposits.sepa_transfer) }}</li>
            <li><b>Otros: </b> {{ fmtMoney(this.deposits.other) }}</li>
          </ul>

          <template v-if="accounting_show_vat">
            <div v-for="(summary, vat_type) in deposits_by_vat">
              <h6>
                <strong>
                  <span v-if="vat_type == 7">IGIC&nbsp;</span>
                  <span v-else>IVA&nbsp;</span>
                  <span v-if="vat_type != 0">{{ vat_type }}%</span>
                  <span v-else>Exento</span>
                </strong>
              </h6>
              <ul>
                <li><strong>Base: </strong>{{ fmtMoney(summary.base) }}</li>
                <li><strong>Imp: </strong>{{ fmtMoney(summary.vat) }}</li>
                <li><strong>Total: </strong>{{ fmtMoney(summary.total) }}</li>
              </ul>
            </div>
          </template>
        </div>

        <div v-if="this.assignments && this.assignments.total" class="clinic-payments__summary">
          <h5>
            <strong>
              <span v-if="enable_payments_v2">ASIGNACIONES:</span>
              <span v-else>TOTAL:</span>
            </strong>
            {{ total_assignments }}
          </h5>
          <ul>
            <li><b>Efectivo: </b> {{ fmtMoney(this.assignments.cash) }}</li>
            <li>
              <b>Tarjeta: </b> {{ fmtMoney(this.assignments.credit_card) }}
            </li>
            <li>
              <b>Financ.: </b> {{ fmtMoney(this.assignments.direct_debit) }}
            </li>
            <li>
              <b>Int. Fin.: </b>
              {{ fmtMoney(this.assignments.expense_interests) }}
            </li>
            <li><b>Bizum: </b> {{ fmtMoney(this.assignments.mobile) }}</li>
            <li><b>Transf.: </b> {{ fmtMoney(this.assignments.transfer) }}</li>
            <li><b>TPV: </b> {{ fmtMoney(this.assignments.tpv) }}</li>
            <li v-if="enable_sepa_transfers"><b>Adeudo SEPA: </b> {{ fmtMoney(this.assignments.sepa_transfer) }}
            </li>
            <li><b>Otros: </b> {{ fmtMoney(this.assignments.other) }}</li>
          </ul>

          <template v-if="accounting_show_vat">
            <div v-for="(summary, vat_type) in assignments_by_vat">
              <h6>
                <strong>
                  <span v-if="vat_type == 7">IGIC&nbsp;</span>
                  <span v-else>IVA&nbsp;</span>
                  <span v-if="vat_type != 0">{{ vat_type }}%</span>
                  <span v-else>Exento</span>
                </strong>
              </h6>
              <ul>
                <li><strong>Base: </strong>{{ fmtMoney(summary.base) }}</li>
                <li><strong>Imp: </strong>{{ fmtMoney(summary.vat) }}</li>
                <li><strong>Total: </strong>{{ fmtMoney(summary.total) }}</li>
              </ul>
            </div>
          </template>

        </div>
      </div>
      <!-- CENTER COLUMN -->
      <div class="col-md-8">
        <div class="row">
          <div class="col">
            <h1 class="clinic-payments__title">
              {{ page_title }}
            </h1>
          </div>
        </div>

        <div class="clinic-payments__inputs row form-group">

          <div class="col-sm-2">
            <select id="clinic_payments_period" v-model="period" class="custom-select">
              <option value="day">Hoy</option>
              <option value="day_prior">Ayer</option>
              <option value="week">Esta semana</option>
              <option value="week_prior">Semana pasada</option>
              <option value="month">Este mes</option>
              <option value="month_prior">Mes pasado</option>
              <option value="trimester">Este trimestre</option>
              <option value="trimester_prior">Trimestre pasado</option>
              <option value="year">Este año</option>
              <option value="past_year">Año pasado</option>
              <option value="custom">Personalizado</option>
            </select>
            <label for="clinic_payments_period" class="wabident-info">Periodo</label>
          </div>

          <transition name="fade">
            <div class="col-sm-2" v-if="period == 'custom'">
              <input v-model="date_from" id="clinic_payments_date_from" type="date" class="form-control" />
              <label class="wabident-info" for="clinic_payments_date_from">Desde:</label>
            </div>
          </transition>

          <transition name="fade">
            <div class="col-sm-2" v-if="period == 'custom'">
              <input v-model="date_to" id="clinic_payments_date_to" type="date" class="form-control" />
              <label class="wabident-info" for="clinic_payments_date_to">Hasta:</label>
            </div>
          </transition>

          <div class="col-sm-2">
            <!--
            <select id="clinic_payments_type" v-model="type" class="custom-select">
              <option :value="null">Todos</option>
              <option v-for="(type, code) in clinic.payment_types" :key="code" :value="code"> {{ type.name }}
              </option>
            </select>
            -->
            <v-select class="wabident-selector" id="clinic_payments_type" :options="payment_type_options"
              v-model="payment_types" multiple :reduce="x => x.value" placeholder="Elige forma de pago ..."></v-select>
            <label for="clinic_payments_type" class="wabident-info">Forma de pago</label>
          </div>

          <div v-if="enable_payments_subtypes" class="col-sm-2">
            <select id="clinic_payments_subtype" v-model="subtype" class="custom-select">
              <option :value="null">Todos</option>
              <option v-for="(subtype, code) in payment_subtypes" :key="code" :value="code">
                {{ subtype }}
              </option>
            </select>
            <label for="clinic_payments_subtype" class="wabident-info">Subtipo</label>
          </div>

          <div v-if="enable_payments_v2" class="col-sm-2">
            <select id="clinic_payments_type" v-model="accounting_entry" class="custom-select">
              <option value="assignment">Asignación</option>
              <option value="deposit">Depósito</option>
            </select>
            <label for="clinic_payments_type" class="wabident-info">Tipo</label>
          </div>

          <div v-if="invoices_enabled" class="col-sm-2">
            <select id="clinic_payments_is_invoiced" v-model="is_invoiced" class="custom-select">
              <option :value="null">Todos</option>
              <option :value="'invoiced'">Facturados</option>
              <option :value="'uninvoiced'">Sin facturar</option>
            </select>
            <label for="clinic_payments_is_invoiced" class="wabident-info">¿Facturado?</label>
          </div>

          <template v-if="show_clinic_selector">
            <div class="col-sm-2">
              <select id="clinic_payments_clinic_id" v-model="clinic_id" class="custom-select">
                <option :value="null">Todas</option>
                <option v-for="(name, id) in clinics" :key="id" :value="id">
                  {{ name }}
                </option>
              </select>
              <label for="clinic_payments_clinic_id" class="wabident-info">Clínica</label>
            </div>
          </template>
        </div>

        <div class="clinic-payments__inputs row form-group" v-if="accounting_entry == 'assignment'">

          <div class="col-sm-6">
            <v-select multiple class="wabident-selector" @search="searchProducts" :filterable="false"
              :options="products" placeholder="Busca el tratamiento/producto aquí ..."
              v-model="selected_products"></v-select>
            <label class="wabident-info">Tipo de Tratamiento</label>
          </div>

          <div class="col-sm-4">
            <select id="clinic_treatments_show_category" v-model="product_category_id" class="custom-select">
              <option :value="null">Todas</option>
              <option v-for="(cat, id) in categories" :value="cat.id" :key="id">
                {{ cat.name }}
              </option>
            </select>
            <label for="clinic_treatments_show_category" class="wabident-info">Unidad</label>
          </div>

          <div class="col-sm-2" v-if="product_category_id">
            <div class="form-check form-check-inline mb-2">
              <input v-model="product_category_children" type="checkbox" class="form-check-input" value="true"
                id="product_category_children" />
              <label class="form-check-label" for="product_category_children">Incluir sub-unidades </label>
            </div>
          </div>

        </div>

        <div v-if="!is_loading" class="clinic-payments__list">
          <table class="table">
            <thead>
              <tr>
                <th>FECHA</th>
                <th v-if="enable_payments_v2">TIPO</th>
                <th>F.PAGO</th>
                <th>PACIENTE</th>
                <th v-if="clinics.length > 1">CLÍNICA</th>
                <th v-if="invoices_enabled">FACTURA</th>
                <th v-if="is_showing_sepa_assignments">REMESA</th>
                <th>IMPORTE</th>
              </tr>
            </thead>
            <tbody>
              <clinic-payment v-for="(payment, index) in search_payments" class="clinic-payments__row"
                :payment="payment" :clinics="clinics" :key="index" :invoices_enabled="invoices_enabled"
                :show_bank_order="is_showing_sepa_assignments" @invoice="emitInvoice"
                @payment="updatePayment"></clinic-payment>
            </tbody>
          </table>
        </div>
        <div v-else class="clinic-payments__loading text-center">
          <h2>
            Buscando
            <i class="fas fa-spin fa-circle-notch"></i>
          </h2>
        </div>

        <!-- PAGINATION -->
        <div v-if="has_results_available" class="row">
          <div class="col text-center customer-search-pagination my-2">
            <button :disabled="is_first_page" @click="goFirst" type="button"
              class="btn btn-primary btn-wabident-round mx-1">
              <i class="fas fa-angle-double-left"></i>
            </button>
            <button :disabled="is_first_page" @click="goPrev" type="button"
              class="btn btn-primary btn-wabident-round mx-1">
              <i class="fas fa-angle-left"></i>
            </button>
            <label class="customer-search-pagination-locator mx-2">
              Página
              {{ current_page }} de {{ total_pages }}
            </label>
            <button :disabled="is_last_page" @click="goNext" type="button"
              class="btn btn-primary btn-wabident-round mx-1">
              <i class="fas fa-angle-right"></i>
            </button>
            <button :disabled="is_last_page" @click="goLast" type="button"
              class="btn btn-primary btn-wabident-round mx-1">
              <i class="fas fa-angle-double-right"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- RIGHT COLUMN -- ACTIONS -->
      <div class="col-md-2">
        <h1 class="clinic-payments__title">ACCIONES</h1>
        <div class="clinic-payments__inputs row form-group">
          <div class="col clinic-payments__summary d-flex flex-column justify-content-start align-items-center">

            <button v-if="invoices_enabled && can_invoice" :disabled="is_loading" @click="invoicePending"
              class="btn btn-primary btn-wabident btn-block d-flex align-items-center justify-content-center">
              <i style="font-size: 24px; margin-right: 20px" class="fas fa-file-invoice"></i>
              Facturar Pendientes
            </button>

            <button :disabled="is_loading" @click="generateReport('xls')"
              class="btn btn-primary btn-wabident btn-block d-flex align-items-center justify-content-center">
              <i style="font-size: 24px; margin-right: 20px" class="fas fa-download"></i>
              Descargar Excel
            </button>

            <button :disabled="is_loading" @click="generateReport('csv')"
              class="btn btn-primary btn-wabident btn-block d-flex align-items-center justify-content-center">
              <i style="font-size: 24px; margin-right: 20px" class="fas fa-download"></i>
              Descargar CSV
            </button>

            <button :disabled="is_loading" @click="generateReport('pdf')"
              class="btn btn-primary btn-wabident btn-block d-flex align-items-center justify-content-center">
              <i style="font-size: 24px; margin-right: 20px" class="wabident icon-wabident-print"></i>
              Imprimir
            </button>

            <button :disabled="is_loading" @click="sendPayments"
              class="btn btn-primary btn-wabident btn-block d-flex align-items-center justify-content-center">
              <i style="font-size: 24px; margin-right: 20px" class="wabident icon-wabident-mail"></i>
              Enviar
            </button>

            <button v-if="is_showing_sepa_assignments" :disabled="is_loading"
              class="btn btn-primary btn-wabident btn-block d-flex align-items-center justify-content-center"
              @click="generateBankOrder">
              <i style="font-size: 24px; margin-right: 20px" class="fas fa-money-bill-alt"></i>
              Crear Remesa
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      page: 0,
      is_loading: false,
      period: "day",
      date_from: new Date().toISODate(),
      date_to: new Date().toISODate(),
      type: null,
      payment_types: [],
      subtype: null,
      clinic_id: null,
      payments: null,
      is_invoiced: null,
      summary: [],
      deposits: [],
      assignments: [],
      deposits_by_vat: [],
      assignments_by_vat: [],
      selected_customer: null,
      selected_invoices: [],
      simulating_invoices: true,
      simulated_invoices: [],
      accounting_entry: "deposit",
      simulated_invoices_date: new Date().toISODate(),
      simulated_invoices_date_type: "choose",
      selected_products: [],
      searched_products: [],
      products: [],
      product_category_id: null,
      product_category_children: null,
      hierarchy: [],
    };
  },
  computed: {
    categories() {
      let ret = [];
      this.hierarchy.forEach((cat) => {
        this.addCategory(cat, ret, 0);
      });
      return ret;
    },
    is_showing_sepa_assignments() {
      return this.accounting_entry == 'assignment' && (this.type == 'sepa_transfer' || this.payment_types.includes('sepa_transfer'));
    },
    page_title() {
      return this.accounting_entry == 'deposit' ? 'PAGOS: Depósitos' : 'PAGOS: Asignaciones';
    },
    disable_deposit_invoicing() {
      return this.clinic && this.clinic.config.clinic_payments_disable_deposit_invoicing;
    },
    can_invoice() {
      return true;
    },
    enable_payments_subtypes() {
      if (!this.clinic || !this.clinic.config.payments_enable_subtypes) {
        return false;
      }

      if (!this.type || !this.payment_types.length) {
        return false;
      }

      return Object.keys(this.payment_subtypes).length > 0;
    },
    payment_type_options() {
      let ret = [];
      if (this.clinic) {
        for (const t in this.clinic.payment_types) {
          ret.push({
            label: this.clinic.payment_types[t].name,
            value: t,
          });
        }
      }
      return ret;
    },
    payment_subtypes() {
      let payment_type = this.type;
      if (!selected && this.payment_types.length > 0) {
        payment_type = this.payment_types[0];
      }

      const selected = this.clinic.payment_types[payment_type].subtypes;
      return selected ? selected : {};
    },
    enable_sepa_transfers() {
      return this.clinic && this.clinic.config.payments_enable_sepa_transfers;
    },
    invoices_enabled() {
      const inv_enabled = this.clinic && this.clinic.config && !this.clinic.config.disable_invoices;

      if (this.accounting_entry == 'deposit') {
        return inv_enabled && !this.disable_deposit_invoicing;
      }

      return inv_enabled;
    },
    accounting_show_vat() {
      return this.clinic && this.clinic.config && this.clinic.config.accounting_show_vat;
    },
    total() {
      if (!this.summary.total) return "";
      return WabiDent.fmtMoney(this.summary.total, 2);
    },
    total_deposits() {
      if (!this.deposits) return "";
      return WabiDent.fmtMoney(this.deposits.total, 2);
    },
    total_assignments() {
      if (!this.assignments) return "";
      return WabiDent.fmtMoney(this.assignments.total, 2);
    },
    show_clinic_selector() {
      return Object.keys(this.clinics).length > 1;
    },
    is_first_page() {
      if (!this.has_results_available) return true;
      return this.payments.current_page == 1;
    },
    is_last_page() {
      if (!this.has_results_available) return true;
      return this.payments.current_page == this.payments.last_page;
    },
    is_first_page() {
      if (!this.has_results_available) return true;
      return this.payments.current_page == 1;
    },
    is_last_page() {
      if (!this.has_results_available) return true;
      return this.payments.current_page == this.payments.last_page;
    },
    search_payments() {
      if (this.is_searching) return [];
      if (!this.payments) return [];
      if (!this.payments.data) return [];
      return this.payments.data;
    },
    current_page() {
      if (!this.has_results_available) return 0;
      return this.payments.current_page;
    },
    total_pages() {
      if (!this.has_results_available) return 0;
      return this.payments.last_page;
    },
    has_results_available() {
      if (this.is_loading) {
        return false;
      }

      if (!this.payments) {
        return false;
      }

      return this.payments.data.length > 0;
    },
    is_aesthetic() {
      if (!this.clinic) return false;
      return this.clinic.type == "aesthetic";
    },
    clinics() {
      if (!this.clinic) return [];
      return this.clinic.clinic_names;
    },
    enable_payments_v2() {
      if (!this.clinic) return false;
      return this.clinic.config.enable_payments_v2;
    },
    ...mapGetters(["msgwindow", "clinic", "errorwindow", "is_core"]),
  },
  watch: {
    accounting_entry() {
      this.page = 1;
      this.loadPayments();
    },
    type() {
      this.subtype = null;
      this.page = 1;
      this.loadPayments();
    },
    subtype() {
      this.page = 1;
      this.loadPayments();
    },
    period() {
      this.page = 1;
      this.loadPayments();
    },
    date_from() {
      this.page = 1;
      this.loadPayments();
    },
    date_to() {
      this.page = 1;
      this.loadPayments();
    },
    clinic_id() {
      this.page = 1;
      this.loadPayments();
    },
    is_invoiced() {
      this.page = 1;
      this.loadPayments();
    },
    product_category_children(val) {
      this.page = 1;
      this.loadPayments();
    },
    product_category_id(val) {
      this.page = 1;
      this.loadPayments();
    },
    selected_products(val) {
      this.page = 1;
      this.loadPayments();
    },
    payment_types(val) {
      this.page = 1;
      this.loadPayments();
    }
  },
  methods: {
    addCategory(cat, ret, level) {
      let prefix = '-'.repeat(level);

      ret.push({
        id: cat.id,
        slug: cat.slug,
        name: prefix + cat.name,
        parent_id: cat.parent_id,
        level: level
      });

      cat.children.forEach((subcat) => {
        this.addCategory(subcat, ret, level + 1);
      });
    },
    loadCategories() {
      axios
        .get("/product/hierarchy")
        .then((response) => {
          this.hierarchy = response.data;
        });
    },
    fmtMoney(value) {
      return WabiDent.fmtMoney(value, 2);
    },
    onSubmit() {
      this.loadPayments();
    },
    emitInvoice(payment) {
      this.selected_customer = payment.customer;
      this.$refs.showinvoice.$forceUpdate();
      this.$refs.showinvoice.showNewPayment(payment);
    },
    updatePayment(payment) {
      this.selected_customer = payment.customer;
      this.$refs.showpayment.$forceUpdate();
      this.$refs.showpayment.showEdit(payment);
    },
    userCan(cap) {
      if (!this.clinic) return false;
      if (!this.clinic.capabilities) return false;
      return this.clinic.capabilities[cap] || false;
    },
    invoicePending() {
      this.simulateInvoices();
      this.$refs.invoicepending.show();
    },
    simulateInvoices() {
      this.simulating_invoices = true;

      let params = {
        period: this.period,
        date_from: this.date_from,
        date_to: this.date_to,
        type: this.type,
        subtype: this.subtype,
        clinic_id: this.clinic_id,
        accounting_entry: this.accounting_entry,
        product_category_id: this.product_category_id,
        product_ids: this.getSelectedProductsIds(),
        product_category_children: Boolean(this.product_category_children) ? 1 : 0,
        payment_types: this.payment_types,
      };

      axios
        .get("/clinic/payments/simulate_invoices", { params })
        .then((response) => {
          this.simulated_invoices = response.data;
          this.simulated_invoices.payments.sort((a, b) => {
            return b.pay_date.localeCompare(a.pay_date);
          });
        })
        .catch((error) => {
          console.log("[ERR] loadPayments ", error);
          this.msgwindow.error("Error cargando simulación de pagos");
        })
        .then(() => {
          this.simulating_invoices = false;
        });
    },
    getInvoicePayDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    getInvoiceCustomer(invoice, customers) {
      let customer = customers[invoice.customer_id] || null;
      if (customer) {
        return customer.full_name;
      }
      return "";
    },
    confirmGenerateInvoices() {
      let len = this.simulated_invoices.payments.length || 0;
      let msg = `Esta operación generará ${len} Facturas. ¿Está segur@?`;

      this.errorwindow.show("Confirmación", msg, "Aceptar", "Cancelar", () => {
        this.$refs.invoicepending.hide();
        this.doGenerateInvoices();
      });
    },
    doGenerateInvoices() {
      let params = {
        period: this.period,
        date_from: this.date_from,
        date_to: this.date_to,
        type: this.type,
        subtype: this.subtype,
        clinic_id: this.clinic_id,
        invoice_date: this.simulated_invoices_date,
        date_type: this.simulated_invoices_date_type,
        accounting_entry: this.accounting_entry,
        product_category_id: this.product_category_id,
        product_ids: this.getSelectedProductsIds(),
        product_category_children: Boolean(this.product_category_children) ? 1 : 0,
        payment_types: this.payment_types,
      };

      this.msgwindow.info("Generando facturas ...");

      axios
        .post("/clinic/payments/generate_invoices", params)
        .then(() => {
          this.msgwindow.success("Facturas generadas");
          this.loadPayments();
        })
        .catch((error) => {
          console.log("[ERR] loadPayments ", error);
          this.msgwindow.error("Error generando facturas");
        });
    },
    cancelSimulatedInvoices() {
      this.$refs.invoicepending.hide();
      this.simulating_invoices = true;
      this.simulated_invoices = [];
    },
    generateReport(report_type) {

      let base_params = {
        period: this.period,
        date_from: this.date_from,
        date_to: this.date_to,
        type: this.type,
        subtype: this.subtype,
        clinic_id: this.clinic_id,
        is_invoiced: this.is_invoiced,
        accounting_entry: this.accounting_entry,
        product_category_id: this.product_category_id,
        product_ids: this.getSelectedProductsIds(),
        product_category_children: Boolean(this.product_category_children) ? 1 : 0,
        payment_types: this.payment_types,
      };

      base_params[report_type] = true;
      let query_string = [];

      for (const key in base_params) {
        let value = base_params[key];
        if (Array.isArray(value)) {
          if (value.length > 0) {
            value.forEach((v) => {
              query_string.push(`${key}[]=${v}`);
            });
          }
        } else {
          if (value) {
            query_string.push(`${key}=${value}`);
          }
        }
      }

      let url = "/clinic/payments?" + query_string.join('&');
      window.open(url);
    },
    loadPayments() {
      if (!this.is_loading) {
        this.is_loading = true;
        let params = {
          period: this.period,
          date_from: this.date_from,
          date_to: this.date_to,
          type: this.type,
          subtype: this.subtype,
          clinic_id: this.clinic_id,
          page: this.page,
          is_invoiced: this.is_invoiced,
          accounting_entry: this.accounting_entry,
          product_category_id: this.product_category_id,
          product_ids: this.getSelectedProductsIds(),
          product_category_children: Boolean(this.product_category_children) ? 1 : 0,
          payment_types: this.payment_types,
        };
        axios
          .get("/clinic/payments", { params })
          .then((response) => {
            this.payments = response.data.payments;
            this.page = response.data.payments.current_page;
            this.summary = response.data.summary;
            this.deposits = response.data.deposits;
            this.assignments = response.data.assignments;
            this.deposits_by_vat = response.data.deposits_by_vat;
            this.assignments_by_vat = response.data.assignments_by_vat;
            this.date_from = response.data.params.date_from;
            this.date_to = response.data.params.date_to;
          })
          .catch((error) => {
            console.log("[ERR] loadPayments ", error);
            this.msgwindow.error("Error cargando pagos");
          })
          .then(() => {
            this.is_loading = false;
          });
      }
    },
    sendPayments() {
      if (!this.is_loading) {
        this.is_loading = true;
        let params = {
          period: this.period,
          date_from: this.date_from,
          date_to: this.date_to,
          type: this.type,
          subtype: this.subtype,
          clinic_id: this.clinic_id,
          email: true,
          is_invoiced: this.is_invoiced,
          accounting_entry: this.accounting_entry,
          product_category_id: this.product_category_id,
          product_ids: this.getSelectedProductsIds(),
          product_category_children: Boolean(this.product_category_children) ? 1 : 0,
          payment_types: this.payment_types,
        };
        this.msgwindow.info("Enviando correo ...");
        axios
          .get("/clinic/payments", { params })
          .then((response) => {
            if (response.data.error) {
              this.msgwindow.error(
                "Error enviando correo :" + response.data.error
              );
            } else {
              this.msgwindow.success("Correo enviado");
            }
          })
          .catch((error) => {
            console.log("[ERR] loadPayments ", error);
            this.msgwindow.error("Error enviando correo");
          })
          .then(() => {
            this.is_loading = false;
          });
      }
    },
    generateBankOrder() {
      this.$refs.newbankorder.show();
    },
    doGenerateBankOrder(pay_date, mark_as_paid) {
      if (!this.is_loading) {
        this.is_loading = true;
        let params = {
          period: this.period,
          date_from: this.date_from,
          date_to: this.date_to,
          type: this.type,
          subtype: this.subtype,
          clinic_id: this.clinic_id,
          bank_order: true,
          is_invoiced: this.is_invoiced,
          accounting_entry: this.accounting_entry,
          pay_date: pay_date,
          mark_as_paid: mark_as_paid,
          product_category_id: this.product_category_id,
          product_ids: this.getSelectedProductsIds(),
          product_category_children: Boolean(this.product_category_children) ? 1 : 0,
          payment_types: this.payment_types,
        };
        this.msgwindow.info("Generando Remesas, esto puede tardar unos segundos ...");
        axios
          .get("/clinic/payments", { params })
          .then((response) => {
            if (response.data.error) {
              this.errorwindow.show(
                "Error generando Remesa",
                response.data.error
              );
            } if (response.data.message) {
              this.errorwindow.show('Remesa - Información', response.data.message, 'Aceptar');
            } else {
              this.msgwindow.success("Remesa generada");
            }
          })
          .catch((error) => {
            console.log("[ERR] loadPayments ", error);
            this.errowindow.show("Error", "Error generando Remesas - Contacte con el Administrador");
          })
          .then(() => {
            this.is_loading = false;
            this.loadPayments();
          });
      }
    },
    goFirst() {
      this.page = 1;
      this.loadPayments();
    },
    goPrev() {
      this.page -= 1;
      this.loadPayments();
    },
    goNext() {
      this.page += 1;
      this.loadPayments();
    },
    goLast() {
      this.page = this.total_pages;
      this.loadPayments();
    },
    getSelectedProductsIds() {
      return this.selected_products.map((x) => {
        return x.value;
      });
    },
    searchProducts(search, loading) {
      loading(true);
      axios
        .get("/product", {
          params: {
            search: search,
          },
        })
        .then((response) => {
          this.fillSearchedProducts(response.data.data);
        })
        .catch((error) => {
          console.log("[ERR] searchProducts:", error);
        })
        .then(() => {
          loading(false);
        });
    },
    fillSearchedProducts(products) {
      this.searched_products = products;
      this.products = products.map((p) => {
        return {
          label: p.name,
          value: p.id,
        };
      });
    },
  },
  mounted() {
    this.accounting_entry = this.enable_payments_v2 ? 'deposit' : 'assignment';
    if (this.clinic.config.clinic_payments_show_assignments) {
      this.accounting_entry = 'assignment';
    }

    this.loadCategories();
    this.loadPayments();
  },
};
</script>

<style lang="scss">
.clinic-payments {
  &__title {
    font-size: 32px;
    color: var(--theme-text-color);
    font-weight: 800;
    letter-spacing: 0.5px;
    line-height: 1.31;
    margin-bottom: 25px;
  }

  &__list {
    width: 100%;

    table {
      th {
        font-size: 15px;
        letter-spacing: 0.3px;
        color: var(--theme-grey);
        border: none;
        position: sticky;
        top: 0;
        z-index: 1;
        background: white;
        border-bottom: 1px #e0e0e0 solid;
      }

      &__row {
        cursor: pointer;
        background-color: transparent;
        transition: all 0.2s;
        border-bottom: 1px #e0e0e0 solid;
        border-top: 1px #e0e0e0 solid;

        &:hover {
          background-color: var(--theme-highlight);
        }

        td {
          font-size: 16px;
          line-height: 20px;
          color: var(--theme-text-color);
        }
      }
    }
  }
}
</style>
